module.exports = __webpack_public_path__ + "static/media/acore.45afae5b.png";